import { ReactElement } from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { Placement } from 'react-bootstrap/esm/Overlay'
import './index.scss'

type CustomTooltipProps = {
  direction?: Placement
  content: string | React.ReactNode
  showDelay?: number
  hideDelay?: number
  opacity?: string
  targetElement: ReactElement
  bsPrefixClass?: string
  offset?: number[]
}

// Direction can be "right", "left", "top", "bottom"
const CustomTooltip: React.FC<CustomTooltipProps> = ({
  direction = 'auto',
  content,
  showDelay = 250,
  hideDelay = 1000,
  targetElement,
  bsPrefixClass = 'DefaultCustomTooltip',
  offset = [],
}) => {
  return (
    <OverlayTrigger
      placement={direction}
      popperConfig={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: offset, // First value: horizontal offset, second: vertical offset
            },
          },
        ],
      }}
      delay={{ show: showDelay, hide: hideDelay }}
      overlay={
        <Tooltip id="custom-tooltip" bsPrefix={bsPrefixClass}>
          {content}
        </Tooltip>
      }
    >
      {targetElement}
    </OverlayTrigger>
  )
}

export default CustomTooltip
